module.exports = __webpack_public_path__ + "static/anjali-6efcb5223c0148bde0a6a367a72886c3.jpeg";